// src/components/Control/SystemStatus.tsx
import React from 'react';
import { RobotControlData } from '../../../types';

interface SystemStatusProps {
  robotData: Pick<RobotControlData, 'lastCommand' | 'currentTime' | 'systemStatus'>;
}

const SystemStatus: React.FC<SystemStatusProps> = ({ robotData }) => {
  return (
    <div className="status-info">
      <div className="status-item">
        <span className="label">Последняя команда:</span>
        <span id="lastCommand">{robotData.lastCommand}</span>
      </div>
      <div className="status-item">
        <span className="label">Время:</span>
        <span id="currentTime">{robotData.currentTime}</span>
      </div>
      <div className="status-item">
        <span className="label">Статус:</span>
        <span id="systemStatus">{robotData.systemStatus}</span>
      </div>
    </div>
  );
};

export default SystemStatus;